<app-side-menu>
  <div class="b2b-ops-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <button type="button" class="btn-back" (click)="back()"><i class="fas fa-arrow-left"></i></button>
          <h1 class="page-title"><i class="fas fa-file-invoice me-2"></i>{{ invoice?.invoiceNumber || 'Fatura' }}</h1>
          <p class="page-subtitle" *ngIf="contractDisplayName">
            {{ contractDisplayName }}
            <span *ngIf="contractNumber"> · {{ contractNumber }}</span>
          </p>
        </div>
        <div class="d-flex gap-2 flex-wrap" *ngIf="invoice">
          <app-button text="Excel" color="var(--success-color)" height="40px" (buttonClick)="export('xlsx')">
            <i class="fas fa-file-excel me-2"></i>
          </app-button>
          <app-button text="PDF" color="var(--danger-color, #dc3545)" height="40px" (buttonClick)="export('pdf')">
            <i class="fas fa-file-pdf me-2"></i>
          </app-button>
          <app-button
            *ngIf="canIssue"
            text="Emitir (só CR)"
            color="var(--primary-color)"
            height="40px"
            [disabled]="acting"
            (buttonClick)="issue()">
            <i class="fas fa-check me-2"></i>
          </app-button>
          <app-button
            *ngIf="canOpenCr"
            text="Ver Contas a Receber"
            color="var(--secondary-color)"
            height="40px"
            (buttonClick)="openAccountsReceivable()">
            <i class="fas fa-file-invoice-dollar me-2"></i>
          </app-button>
        </div>
      </div>
    </div>

    <app-b2b-operational-nav *ngIf="contractId" [contractId]="contractId" active="faturas"></app-b2b-operational-nav>

    <div class="b2b-ops-card" *ngIf="loading">Carregando fatura…</div>

    <div class="b2b-ops-card" *ngIf="!loading && invoice">
      <div class="row g-3 mb-3">
        <div class="col-md-3">
          <div class="text-muted small">Categoria</div>
          <strong>{{ invoice.categoryLabel || invoice.category }}</strong>
        </div>
        <div class="col-md-3">
          <div class="text-muted small">Competência</div>
          <strong>{{ invoice.competenceMonth | number:'2.0-0' }}/{{ invoice.competenceYear }}</strong>
        </div>
        <div class="col-md-3">
          <div class="text-muted small">Status</div>
          <strong>{{ statusLabel(invoice.status) }}</strong>
        </div>
        <div class="col-md-3">
          <div class="text-muted small">Total</div>
          <strong>{{ formatMoney(invoice.totalAmount) }}</strong>
        </div>
      </div>

      <p class="text-muted mb-3" *ngIf="invoice.accountsReceivableId">
        Título Contas a Receber: <strong>#{{ invoice.accountsReceivableId }}</strong>
        — espelho financeiro (sem cobrança automática no Asaas).
      </p>
      <p class="text-muted mb-3" *ngIf="!invoice.accountsReceivableId && invoice.status === 'Draft'">
        Rascunho: ao emitir, cria só o Contas a Receber. O cliente vê o espelho no portal após a emissão.
      </p>

      <h3 class="mb-2">Itens ({{ invoice.items?.length || 0 }})</h3>
      <div class="table-responsive" style="max-height: 60vh; overflow: auto;">
        <table class="table table-sm table-hover mb-0">
          <thead>
            <tr>
              <th style="width:56px">#</th>
              <th>Placa</th>
              <th>Descrição</th>
              <th>Data</th>
              <th>Dias</th>
              <th class="text-end">Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let line of invoice.items; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ line.plate || '—' }}</td>
              <td>{{ line.description || '—' }}</td>
              <td>{{ formatLineDate(line.periodStart) }}</td>
              <td>{{ line.days ?? '—' }}</td>
              <td class="text-end">{{ formatMoney(line.amount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</app-side-menu>
